
import {
  HomeIcon,
  GanttChartIcon,
  Receipt,
  UserRound,
  Users,
  BarChart3,
} from "lucide-react";

export interface NavigationItem {
  path: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  adminOnly?: boolean;
}

export const navigationItems: NavigationItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: HomeIcon },
  { path: "/projects", label: "Projects", icon: GanttChartIcon },
  { path: "/team-projects", label: "Team Projects", icon: Users },
  { path: "/analytics", label: "Analytics", icon: BarChart3 },
  { path: "/invoices", label: "Invoices", icon: Receipt },
  { path: "/profile", label: "Profile", icon: UserRound },
  { path: "/admin/dashboard", label: "Admin Dashboard", icon: BarChart3, adminOnly: true },
];

export const getVisibleNavigationItems = (isAdmin: boolean) => {
  return navigationItems.filter(item => !item.adminOnly || isAdmin);
};
